<template>
  <div class="map">
    <div class="map-locate1 pointer" @click="changeActivePoint(2)"></div>
    <div class="map-locate2 pointer" @click="changeActivePoint(1)"></div>
    <div class="map-locate3 pointer" @click="changeActivePoint(0)"></div>
    <el-image class="map-img" :src="mapImg" fit="cover"></el-image>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mapImg: this.$oss("CorrosionMonitorScreen/device-map.png"),
      activePoint: 0,
    };
  },

  methods: {
    changeActivePoint(index) {
      this.activePoint = index;
      this.$emit("changeActivePoint", index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";
.map {
  flex: 1;
  position: relative;
  width: 100%;
  height: calc(100% - 100vh / 1080 * 36);
  &-con {
    width: 100%;
    height: 100%;
  }

  &-locate1 {
    position: absolute;
    top: 65%;
    left: 56%;
    background: transparent;
    width: calc(100vw / 1920 * 132);
    height: calc(100vh / 1080 * 44);
    z-index: 2;
    //background: #000000;
  }

  &-locate2 {
    position: absolute;
    top: 7.55%;
    left: 54%;

    background: transparent;
    //background: #000000;
    width: calc(100vw / 1920 * 110);
    height: calc(100vh / 1080 * 44);
    z-index: 2;
  }

  &-locate3 {
    position: absolute;
    top: 50%;
    left: 5%;

    background: transparent;
    //background: #000000;
    width: calc(100vw / 1920 * 110);
    height: calc(100vh / 1080 * 44);
    z-index: 2;
  }

  &-img {
    width: 100%;
    height: 100%;
  }
}
</style>
